import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors, {
	addon_plus_devices_g3,
} from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import safety_gen_2_auto_recovery_under_voltage from '@devices/settings/device_settings/safety_gen_2_auto_recovery_under_voltage.js';
import app_setting_pm_gen_2 from '@devices/settings/device_settings/app_setting_pm_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import multi_settings_gen_2 from '@devices/settings/device_settings/multi_settings_gen_2.js';
import roller_plus_pm_settings_gen_3 from '@devices/settings/common_settings/roller_plus_pm_settings_gen_3';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';

export default {
	name: 'Shelly2PMG4',
	friendly_name: '2PM Gen4',
	family: 'relay',
	isPM: true,
	gen: 2,
	addons: addon_plus_devices_g3,
	reset_from_input: true,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				virtual_components,
				safety_gen_2_auto_recovery_under_voltage,
				app_setting_pm_gen_2,
				share,
				multi_settings_gen_2,
			],
		},
		roller: {
			availableViews: ['advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			slider: true,
			settings: roller_plus_pm_settings_gen_3,
		},
	},
};
